/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import './video.scss';
import Icon, { IconType, IconSize } from '../icon/icon';

const Video = forwardRef((props, ref) => {
  const { src, className } = props;
  const videoRef = useRef();
  // const [play, setPlay] = useState(false);
  const [srcState, setSrc] = useState(src);

  // const playOrPause = () => {
  //   const newVideoState = !play;
  //   setPlay(newVideoState);
  //   if (newVideoState) {
  //     videoRef.current.play();
  //   } else {
  //     videoRef.current.pause();
  //   }
  // };

  useImperativeHandle(ref, () => ({
    updateValue(newValue) {
      setSrc(newValue);
      videoRef.current.load();
    },
  }));

  return (
    <div className={`video position-relative ${className}`}>
      <video>
        <source src={srcState} />
        Non-playable format
      </video>
      <button
        type="button"
        // onClick={playOrPause}
        className="video__controls d-flex justify-content-center align-items-center"
      >
        <Icon icon={IconType.PLAY} iconColor="#adadad" iconSize={IconSize.LARGE} />
      </button>
    </div>
  );
});

Video.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Video.defaultProps = {
  className: '',
};

export default Video;
